import React, { useState } from 'react';

const PasswordInput = ({ id, label = 'Password', value, onChange, disabled, autoComplete }) => {
  const [isVisible, setIsVisible] = useState(false);
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="auth-password-field">
      <label className="db fw6 lh-copy f6" htmlFor={inputId}>{label}</label>
      <div className="auth-password-control">
        <input
          id={inputId}
          className="auth-input auth-password-input"
          type={isVisible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          disabled={disabled}
          autoComplete={autoComplete}
        />
        <button
          className="auth-password-toggle"
          type="button"
          onClick={() => setIsVisible((currentValue) => !currentValue)}
          disabled={disabled}
          aria-label={isVisible ? 'Hide password' : 'Show password'}
          aria-pressed={isVisible}
        >
          <svg className="auth-password-toggle-icon" viewBox="0 0 24 24" aria-hidden="true">
            {isVisible ? (
              <>
                <path d="M2.5 11.2C3.6 9.3 7 5 12 5s8.4 4.3 9.5 6.2a1.5 1.5 0 0 1 0 1.6C20.4 14.7 17 19 12 19s-8.4-4.3-9.5-6.2a1.5 1.5 0 0 1 0-1.6Z" />
                <circle cx="12" cy="12" r="2.8" />
              </>
            ) : (
              <>
                <path d="M3 3l18 18" />
                <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
                <path d="M9.9 5.2A9.7 9.7 0 0 1 12 5c5 0 8.4 4.3 9.5 6.2a1.5 1.5 0 0 1 0 1.6 15.5 15.5 0 0 1-2.2 2.8" />
                <path d="M6.7 6.7A15.8 15.8 0 0 0 2.5 11.2a1.5 1.5 0 0 0 0 1.6C3.6 14.7 7 19 12 19c1.4 0 2.7-.3 3.9-.9" />
              </>
            )}
          </svg>
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
